import React from "react";

const LockerRoomPerryOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="202.501"
      height="93.768"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 202.501 93.768"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-2228.869 -314.594)"
      >
        <path
          strokeWidth="3"
          d="M2303.28 345.185l43.03 42.88s.59 7.978 7.05 13.636c10.08 8.834 18.69 4.682 23.83-.238 3.53-3.379 10.57-11.835.92-22.908-5.98-6.858-15.75-5.873-15.75-5.873l-45.47-41.321"
          opacity="1"
        ></path>
        <path
          strokeWidth="5"
          d="M2302.39 346.9s1.67-8.064 5.94-11.035c4.28-2.97 11.16-5.82 11.16-5.82l-15.16-12.732s-6.58 1.364-10.55 4.487c-3.97 3.122-6.06 10.307-6.06 10.307z"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2307.23 318.708c-.82-.612 1.52-1.248 2.11-1.241 2.47.031 6 .972 8.13 2.134 4.43 2.418 6.05 9.135 5.22 13.763"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2311.34 323.14c10.46-3.809 23.69 6.283 16.4 17.11"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2296.86 319.764c-.76-.197 1.37-3.694 2.09-3.849 2.46-.522 7.13-.581 9.16 1.193"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2296.85 320.101c-.11-1.683-3.82-2.814-5.17-2.526-1.17.25-2.81 1.183-3.84 1.79-4.21 2.474-5.32 8.074-4.4 12.378"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2291.42 324.436c-1.99-.517-3.7-.802-5.77-.568-1.67.19-3.34.334-5.02.134-4.45-.53-10.72-.843-14.03 2.948-.48.547-2.32 1.904-2.36 2.597-.04.614.44.677.54 1.155"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2288.46 329.666c-1.43-1.597-10.81-.793-13.14-1.13-9.2-1.327-19.65-3.48-28.36.835-3.59 1.78-6.83 3.133-6.87 7.595-.06 6.199 12.69 13.095 17.8 14.423 3.48.902 6.88 2.544 10.43 3.128 8.94 1.474 18.37 3.35 28.03 3.645 4.46.136 8.93.042 13.39-.157 2.03-.09 4.41-.798 6.41-.28"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2287.57 333.07c-4.25-1.104-9.1-1.846-13.51-1.649-1.95.086-3.93.52-5.88.502-4.29-.039-8.71-.059-12.82 1.233-2.84.893-10.93 3.48-7.51 7.768 1.98 2.477 10.36 3.702 13.42 4.921 3.69 1.464 7.35 1.635 11.19 2.481 4.12.908 7.97 1.725 12.16 2.312 8.73 1.222 17.53 3.994 26.41 3.392"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2287.35 333.266c-6.87 1.463-14.07 1.857-21.01 3.163-1.18.221-5.8 2.107-5.02 4.021 1.16 2.816 5.94 2.62 8.28 4.26.97.686 3.49 4.034 4.06 4.183"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2240.94 333.046c-1.86-1.205-6.08 3.969-7.01 5.194-3.74 4.937-3.29 11.455 1.85 15.349 7.21 5.469 17.54 5.01 25.92 3.943 2.73-.347 8.41-2.127 11.03-1.447"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2265.12 330.705c-1.81-2.025-11.46 1.247-13.59 2.219-4.08 1.862-11.22 5.557-11.52 10.865-.25 4.318 6.4 11.661 9.81 13.617 10.67 6.11 21.61 6.78 33.7 6.889 4.85.043 9.76.348 14.6.072 5.07-.29 10.16-.811 15.21-1.291.4-.039 8.21-.406 7.32-.887"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2334.95 346.438c-.32-.78 4.59-1.631 5.33-1.662 6.5-.262 13.43.708 19.82 1.874 8.37 1.531 18.9 4.918 26.09 9.678 6.27 4.148 12.24 9.097 18.89 12.608 5.94 3.142 15.14 4.173 21.8 3.745"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2337.29 349.179c-1.07-.451 2.01-.218 2.7-.301 1.93-.231 3.93-.275 5.86-.206 6.23.221 12.37.361 18.6.846 5.7.444 11.03 1.959 16.71 2.625 5.46.642 11.33 1.099 16.66 2.502 3.2.842 6.45 1.922 9.26 3.7 1.83 1.159 3.79 2.947 6.13 2.796"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2343.44 354.143c1.06-.912 3.18-.634 4.52-.461 4.34.562 8.87 2.616 13.2 3.617 5.57 1.287 11.24.317 16.85.108 7.64-.284 15.3-.795 22.95-.2 2.79.218 12.5.116 14.31 2.228"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2348.18 358.516c.23-.537 3.32.057 3.88.091 4.49.27 9.26.383 13.59 1.721 11.63 3.594 23.88 6.212 34.64 12.148 1.89 1.043 4.38 2.64 6.04 3.993 1.87 1.528 3.82 3.878 6.09 4.839"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2420.43 382.112c-.23-3.551-8.08-7.427-11.21-7.616-6.26-.377-13.07 2.774-19.25.94-10-2.972-17.6-13.001-28.42-13.441-2.41-.098-6.35-1.384-8.4.37"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2342.48 354.46c1.85-2.602 11.21-1.295 14.24-.788 13.69 2.29 26.42 6.59 38.58 13.299 3.92 2.162 8.49 3.589 12.94 3.506.89-.017 3.77-.15 4.14-1.032"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2404.69 363.518c-.28-.686-.12-1.789-.79-2.289-3.55-2.668-13.92-.127-18.63-.759-2.05-.275-4.61-.854-6.6-1.447-.65-.193-1.35-.521-2.04-.549-.14-.006-1.28-.132-.84.054"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2357.14 366.829c6.98-.449 19.91 3.265 25.71 6.939 1.86 1.181 4.04 1.702 5.57 3.384 2.68 2.938 5.28 5.766 7.68 8.905.88 1.152 1.52 2.324 2.06 3.653.09.208.49 1.609.46 1.119"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2363.05 371.383c.78-1.041 3.28-1.189 4.55-1.271 4.22-.271 8.87-.603 12.39 2.138 2.47 1.926 4.23 5.21 5.86 7.832 1.16 1.868 2.77 3.366 4.15 5.049 3.37 4.11 5.63 8.595 9.75 12.047 1.49 1.249 2.01 3.114 3.91 3.917"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2381.11 375.198c2.15 3.68.86 5.161 1.32 8.591.54 4.034 2.04 8.391 4.16 11.853 1.62 2.637 5.19 3.651 7.73 5.117.65.372 1.75.927 2.47.734.33-.086 1.3-.338.96-.316"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2403.07 383.951c.04-.573-2.86.073-3.57.144-1.21.121-4.03-.438-5.05-1.206-4.84-3.637-8.97-8.834-14.89-11.334"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2288.56 335.268c-1.83-.057-4.89 3.043-6.39 4.026-2.19 1.432-10.51 7.571-10.26 10.603.14 1.712 2.32 3.548 3.6 4.357 2.28 1.442 5.15 1.84 7.73 2.441 7.99 1.858 16.78 1.349 24.82.112 2.43-.373 4.7-1.137 7.15-1.393"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2291.1 336.321c-2.55-.722-6.33.141-8.94.636-6.53 1.24-14.82 2.699-20.1 7.064-3.17 2.624-8.03 10.941-2.89 14.026 3.64 2.18 8.79 1.65 12.84 1.802 8.56.322 17.09.746 25.65.099 4.51-.339 9.02-.537 13.53-.921.96-.083 6.24-.602 5.69-.972"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2294.15 339.687c-5.21-1.478-17.89 4.869-21.6 8.224-1.74 1.582-4.39 5.724-2.82 8.207 1.55 2.465 5.82 1.378 8.16 1.228 7.18-.462 14.17-1.837 21.21-3.33 2.66-.565 5.15-1.403 7.72-2.232.93-.302 1.92-.416 2.86-.69.38-.11 1.5-.448 1.16-.256"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2298.49 343.502c-3.21-.908-6.27-.987-9.56-1.291-3.39-.313-6.71-1.106-10.1-1.444-4.83-.482-9.73-1.153-14.59-.884-5.73.318-11.15 1.214-15.43 5.302-1.33 1.263-3.02 3.557-1.24 5.238 2.37 2.234 8.13 2.28 11.11 2.313 10.35.115 20.66-2.674 30.92-3.748 1.85-.194 10.55-.863 11.56-1.976"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2290.73 337.633c-.05-1.159-2.31.301-3.43.614-3.38.945-6.83 1.654-10.19 2.7-8.44 2.628-17.42 5.63-24.27 11.471-2.86 2.445-5.31 5.708-2.35 9.175 1.84 2.151 8.75 3.044 11.53 3.767 6.19 1.609 12.38 2.534 18.8 2.241 8.48-.387 16.82-2.47 25.3-2.755 5.65-.19 11.83 1.711 16.99 3.898 1.69.717 3.37 1.379 5.19 1.72.45.085 3.2.673 2.68.843"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2384.01 395.974c0 2.099 3.6 1.793 4.74 1.978 4.27.692 8.36 1.035 11.64 4.125.72.677 1.55 1.147 1.7 2.204"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2384.91 388.458c-.04-.086 1.67.022 2.03.056 1.9.18 3.26 1.289 4.86 2.204 1.69.962 2.71 2.741 4.02 4.126 1.85 1.966 4.21 3.314 6.16 5.142 1.52 1.432 2.85 4.295 5.14 4.295"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2385.53 385.576c-1.22-.61 1.8-.722 2.09-.735 1.75-.079 2.58.305 3.96 1.356 2.37 1.81 3.59 4.687 6.5 5.991 1.28.575 6.46.881 6.67 1.356"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2384.63 382.354c-.25-.247.82-.056 1.02-.056.88 0 1.76-.009 2.65-.057 1.98-.107 4.04-.008 5.94.622 3.31 1.106 5.5 3.885 8.64 5.199 2.51 1.049 5.2 1.037 7.86.904"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2375.4 374.934c.4-1.131 2.38-1.299 3.41-1.701 2.91-1.127 6.74-1.59 9.82-2.078 9.88-1.568 19.98 1.28 29.87 1.599 3.43.11 8.65 1.465 11.87-.094"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2358.88 367.349c-.59-1.219 2.08-1.775 3.3-2.376 3.44-1.707 7.53-2.737 11.26-3.616 14.17-3.342 27.74.574 41.09 5.22"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2415.04 362.881c-2.56-.89-5.12-.8-7.71-1.344-2.82-.596-5.41-2.002-8.27-2.531-8.61-1.588-19.07-1.444-27.4 1.381-3.38 1.146-6.55 2.817-9.71 4.436"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2246.53 329.505c-.45-.623-2.02.994-2.4 1.27-2.36 1.692-4.59 3.753-6.73 5.729-6.5 6.011-12.05 16.644-2.1 22.222 1.4.787 2.49 1.457 4.13 1.612 1.76.166 3.38.559 5.16.395 1.46-.135 3.05.393 4.48-.051 1.73-.535 3.41-1.296 5.13-1.872"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2231.29 345.791c-.42 3.46 1.04 8.871 4.08 10.984 2.6 1.804 7.5 2.253 10.54 2.14 2.72-.1 5.04-1.47 7.67-1.89"
          opacity="1"
        ></path>
        <path
          strokeWidth="2"
          d="M2288.11 331.398c-.15-.295-.81-.384-1.15-.592-2.98-1.854-6.91-2.586-10.37-2.886-2.78-.241-5.66-.754-8.45-.48-9.27.91-19.63 4.769-26.34 11.298-1.41 1.368-3.15 3.487-3.98 5.289-.82 1.802-.48 5.599.67 7.264.64.938 2.69 1.311 3.72 1.456 3.65.515 7.97-1.393 11.35-2.478 4.33-1.393 8.51-3.146 12.86-4.491"
          opacity="1"
        ></path>
        <path
          strokeWidth="1"
          d="M2367.65 372.8c-.77-.517-3.06.279-3.81.609-3.25 1.423-5.54 2.967-7.49 5.876"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default LockerRoomPerryOutline;
